import { clearInputField, getQueryStringParameter } from '../../../helpers.js'

$(document).ready(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'fiscal_country') {
    return;
  }

  const $differentFiscalAddress   = $('#differentFiscalAddress input[type=radio]', $form);
  const $fiscalAddressIsDifferent = $('#fiscalAddressIsDifferent', $form)

  $differentFiscalAddress.each((_, inputElement) => {
    if(inputElement.checked && inputElement.value === 'true') {
      $fiscalAddressIsDifferent.removeClass('d-none');
    }
  });

  $differentFiscalAddress.on('click', (inputElement) => {
    if(inputElement.target.value === 'true') {
      $fiscalAddressIsDifferent.removeClass('d-none');
    } else {
      clearInputField(document.getElementById('users_profile_natural_fiscal_address'));
      clearInputField(document.getElementById('users_profile_natural_fiscal_zip_code'));
      clearInputField(document.getElementById('users_profile_natural_fiscal_city'));
      clearInputField(document.getElementById('users_profile_natural_fiscal_country'));

      $fiscalAddressIsDifferent.addClass('d-none');
    }
  });
})
